<template>
  <button
    :type="type"
    v-bind="$attrs"
    class="submit bordered"
  >
    {{ text }}
  </button>
</template>

<script>
export default {
  name: "BaseBtn",
  props: {
    type: {
      type: String,
      default: "submit",
    },
    text: {
      type: String,
      default: "Submit",
    },
  },
  inheritAttrs: false, // optional: prevents attrs being added twice
};
</script>

<!-- <template>
  <button
    :type="type"
    v-on="$listeners"
    class="submit bordered"
  >
    {{ text }}
  </button>
</template>

<script>
export default {
  name: "BaseBtn",
  props: {
    type: {
      type: String,
      default: "submit",
    },
    text: {
      type: String,
      default: "Submit",
    },
  },
};
</script> -->
